<template>
  <h2>Characters not found</h2>
</template>

<script>
export default {};
</script>
